<div class="msg" [class.right]="msg.fromID === userId">

  <div *ngIf="msg.type === type.AUDIO" class="audio">
    <audio controls [src]="msg.media.url" #player>
    </audio>

    <div class="audio-wrapper">
      <button *ngIf="!playing" mat-mini-fab color="primary" (click)="play()"><mat-icon>play_arrow</mat-icon></button>
      <button *ngIf="playing" mat-mini-fab color="primary" (click)="stop()"><mat-icon>pause</mat-icon></button>
      <mat-slider (change)="setPosition($event)" color="primary" [(ngModel)]="complete"></mat-slider>
      <div class="time">{{time}}</div>
    </div>
  </div>

  <div *ngIf="msg.type === type.VIDEO" class="video">
    <video controls [src]="msg.media.url" #playerVideo></video>
  </div>

  <div *ngIf="msg.type === type.IMG" class="image">
    <figure>
      <a [href]="msg.media.url" target="_blank">
        <img [src]="msg.media.url">
      </a>
    </figure>
  </div>

  <div *ngIf="msg.type === type.DOC" class="content-doc">
      <a [href]="msg.media.url" target="_blank">
          <div class="doc">
            <mat-icon>insert_drive_file</mat-icon>
            <div class="doc-info">
                <h5>{{ getDocumentName(msg.media) }}</h5>
                <small>{{ getDocumentSize(msg.media) | fileSize}}</small>
            </div>
          </div>
        </a>
  </div>

  <p *ngIf="msg.type === type.TEXT" class="text">{{ msg.message }}</p>

  <small class="time muted" *ngIf="msg && msg.deliveredAt && msg.fromID === userId">
    <span *ngIf="msg.deliveredAt">
      <mat-icon>check</mat-icon>
      {{ msg?.deliveredAt && geDeliveryDate(msg?.deliveredAt) | date: 'HH:m'}}
    </span>

    <span *ngIf="msg.readAt">
      <mat-icon>remove_red_eye</mat-icon>
      {{ msg?.readAt && geDeliveryDate(msg?.readAt) | date: 'HH:m'}}
    </span>

  </small>
</div>


